<script setup>
import GoodsItem from '@/views/Home/components/GoodsItem.vue'
// 以24小时热榜获取数据渲染模版
import { getbrowseListAPI } from '@/apis/user'

import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();

// 设计props参数 适配不同的 title 和 数据
const props = defineProps({
    hotType: {
        type: Number
    }
})

// 适配title 1 - 24小时热榜 2 - 周热榜
const TYPEMAP = {
    1: t("home40"),
}
const title = computed(() => TYPEMAP[props.hotType])

// 1. 封装接口
// 2. 调用接口渲染模版
const hotList = ref([])
const route = useRoute()
const reqData = ref({
    name: '',
    page: 1,
    pageSize: 20,
})
// 总数量
const total = ref(0)
const getHotList = async () => {
    
    const res = await getbrowseListAPI(reqData.value)
    if (res.code == 0) {
        hotList.value = res.data.data
        total.value = res.data.total
    }
}
const noMore = computed(() => {
    if(hotList.value){
       if(hotList.value.length >= total.value) {
        return true;
       }else{
        return false;
       }
    }
})
const loading = ref(false)

const disabled = computed(() => loading.value || noMore.value)
const load = () => {

    loading.value = true
    setTimeout(async () => {
        reqData.value.page++
        const res = await getbrowseListAPI(reqData.value)
        if (res.data.data) {
            hotList.value = [...hotList.value, ...res.data.data]
            loading.value = false
        }
    }, 10)
}
onMounted(() => getHotList());

</script>


<template>
    <div class="goods-hot">
        <!-- <div class="title">{{ title }}</div> -->
        <div class="body">
            <div class="cart-none" v-if="hotList.length === 0">
                <el-empty :description="t('setup11')">
                </el-empty>
            </div>
            <div v-else class="hot-content" v-infinite-scroll="load" :infinite-scroll-disabled="disabled">
                <div class="goods-list">
                        <GoodsItem v-for="(lick, index) in hotList" :key="index" :goods="lick" />
                </div>
                <p v-if="loading" style="text-align: center;padding: 20px 0 10px 0;">Loading...</p>
                <p v-if="noMore" style="text-align: center;padding: 20px 0 10px 0;">No more</p>
            </div>
        </div>
    </div>
</template>


<style scoped lang="scss">
.goods-hot {
    .title {
        height: 70px;
        background: $helpColor;
        color: #fff;
        font-size: 18px;
        line-height: 70px;
        padding-left: 25px;
        margin-bottom: 10px;
        font-weight: normal;
    }

    .hot-content {
        .goods-list {
            display: grid;
    grid-template-columns: repeat(auto-fit, minmax(240px, 0fr));
    grid-auto-rows: 366px;
    grid-gap: 0px;
            //     display: grid;
            //     grid-template-columns: repeat(auto-fit, minmax(267px, 0fr));
            // grid-auto-rows: 410px;
            // grid-gap: 13px;
                justify-content: start;
            }
    }
}

@media (max-width: 768px) {
    .goods-hot {
        background-color: #ffffff;
    .title {
        height: 42px;
        background: #e26237;
        color: #fff;
        font-size: 16px;
        line-height: 42px;
        padding-left: 10px;
        margin-bottom: 0px;
        font-weight: normal;
    
        // padding: 5px 10px;
    }

    .hot-content {
      padding:0 15px ;
        .goods-list {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(calc((100% - 9px) / 2), 0fr));
            grid-auto-rows: 302px;
            // justify-content: center;
            grid-gap: 9px;
            // grid-gap: 10px;
        }
    }
}
}
</style>